import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateFinancialInfoPayload } from './types';

import { apiResourceSchema } from '../common/schemas';
import { QueryKeys } from '../keys';
import { request } from '../request';
import { userSchema } from './schemas';
import { userQueryOptions } from './useUser';

export const useUpdateFinancialInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateFinancialInfoPayload) => {
      const response = await request('/user', { method: 'PATCH', body });

      const { data: user } = apiResourceSchema(userSchema).parse(response);

      return user;
    },
    onSuccess: (user) => {
      queryClient.setQueryData(userQueryOptions.queryKey, () => user);
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
